module.exports = __webpack_public_path__ + "img/login.2fc89590.jpg";